import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const S = {
  Paragraph: styled.p`
    padding-left: 8px;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 0.75rem;
  `,
};

const QuestionInfo = ({ children, className }) => (
  <S.Paragraph className={className}>
    {children}
  </S.Paragraph>
);

QuestionInfo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
QuestionInfo.defaultProps = {
  children: undefined,
  className: undefined,
};

export default QuestionInfo;
